module.exports = __webpack_public_path__ + "img/success-background.6b4f47e8.png";